export { HighlightedSlides } from './HighlightedSlides';
